import styled from "styled-components";

export const DonationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
`

export const DonationFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const DonationFormContentWrapper = styled.div`
  @media (max-width: 1200px) {
    width: 90vw;
  }
`

export const DonationFormRow = styled.div`
  display: flex;

  @media (min-width: 1201px) {
    flex-direction: row;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: left;
  }
`

export const DonationFormColLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  @media (min-width: 1201px) {
    width: 800px;
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
`

export const PaymentElementWrapper = styled.div`
  @media (min-width: 1201px) {
    margin-right: 40px;
    margin-bottom: 30px;
  }

  @media (max-width: 1200px) {
    margin-bottom: 40px;
  }
`

export const DonationFormH2 = styled.h2`
  margin-bottom: 20px;
  
  @media (max-width: 1200px) {
    margin-top: 20px;
  }
`

export const DonationFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 35px;
  margin-bottom: 35px;
  @media (min-width: 1201px) {
    width: 745px;
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
`